import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import Link from "../Link";
import MarketingLink from "../MarketingLink";
import { isMarketingExternal, marketingHomeHref } from "../../utils/marketingLinks";
import Logo from "./Logo";

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.primary.main,
    minHeight: "20vh",
    color: theme.palette.primary.light,
    boxShadow: "1px 1px 20px rgba(0, 0, 0, 0.3)",
  },
  gridBox: {
    display: "flex",
    justifyContent: "center",
    textAlign: "start",
  },
  gridElement: {
    padding: "2rem",
  },
  title: {
    marginBottom: "0.5rem",
  },
  element: {
    color: "#fff",
    textDecoration: "none",
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.75,
    },
  },
  elements: {
    color: "#fff",
    textDecoration: "none",
  },
  list: {
    alignItems: "center",
  },
  logoPadding: {
    padding: "1rem",
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container className={classes.gridBox}>
        <Grid
          item
          xs={12}
          md={12}
          align="center"
          className={classes.logoPadding}
        >
          {isMarketingExternal() ? (
            <a href={marketingHomeHref()} aria-label="Zur Startseite">
              <Logo />
            </a>
          ) : (
            <Link href="/" aria-label="Zur Startseite">
              <Logo />
            </Link>
          )}
        </Grid>
        <Grid item xs={12} md={4} className={classes.gridElement}>
          <Typography variant="h6" component="h2" className={classes.title}>
            M3E Group
          </Typography>

          <Typography variant="body1" className={classes.elements}>
            +49 (0) 30 403672121
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            href="https://m3e-gmbh.com/"
            external
            className={classes.element}
            gutterBottom
          >
            Unternehmensseite
          </Typography>
          <div>
            <Typography
              variant="body1"
              className={classes.element}
              component={MarketingLink}
              marketingKey="impressum"
            >
              Impressum
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={4} className={classes.gridElement}>
          <Typography variant="h6" component="h2" className={classes.title}>
            Adresse
          </Typography>

          <Typography variant="body1" className={classes.elements}>
            Immanuelkirchstrasse 12
          </Typography>
          <Typography variant="body1" className={classes.elements}>
            10405 Berlin
          </Typography>
        </Grid>

        <Grid item xs={12} md={4} className={classes.gridElement}>
          <Typography variant="h6" component="h2" className={classes.title}>
            Rechtliches
          </Typography>
          <div>
            <Typography
              variant="body1"
              className={classes.element}
              component={MarketingLink}
              marketingKey="datenschutz"
            >
              Datenschutz
            </Typography>
          </div>
          <div>
            <Typography
              variant="body1"
              className={classes.element}
              button
              component={MarketingLink}
              marketingKey="agb"
            >
              AGB
            </Typography>
          </div>
          <div>
            <Typography
              variant="body1"
              button
              component={MarketingLink}
              marketingKey="widerrufsbelehrung"
              className={classes.element}
            >
              Widerrufsbelehrung
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
